<template>
  <section class="share">
    <h2 class="share__heading">
      診断をシェアする
    </h2>

    <div class="share__social">
      <social-link
        class="social--large"
        :facebook="share.facebook"
        :twitter="share.twitter"
        :line="share.line"
      />
    </div>

    <div class="share__back">
      <a
        href="../"
        class="link-button link-button--large"
      >
        もう一度診断する
      </a>
    </div>
  </section>
</template>

<script>
import { reactive, onMounted } from 'vue';
import SocialLink from './SocialLink.vue';

export default {
  name: 'ResultFoot',
  components: {
    SocialLink
  },
  props: {
    typeName: {
      type: String,
      default: '',
    }
  },
  setup(props) {
    const baseUrl = 'https://yolo.style/yolo/youareswimmer/';

    const share = reactive({
      twitter: 'http://twitter.com/share?hashtags=%E3%81%8D%E3%81%BF%E3%82%82%E3%82%B9%E3%82%A4%E3%83%9E%E3%83%BC',
      facebook: 'https://www.facebook.com/share.php?u=',
      line: 'http://line.me/R/msg/text/?',
    });

    const setShareUrl = () => {
      if (props.typeName !== '') {
        const shareText = `わたしは「 #${props.typeName} 」でした！\nきみのスイマータイプも診断してみよう！`;
        share.twitter += `&text=${encodeURIComponent(shareText)}`;
        share.line += encodeURIComponent(`${shareText}\n`);
      }
      share.twitter += `&url=${baseUrl}`;
      share.facebook += baseUrl;
      share.line += baseUrl.slice(0,-1) + encodeURIComponent(' #きみもスイマー');
    }

    onMounted(setShareUrl);

    return {
      share
    };
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/foundation/config/mediaquery";

.share {
  padding-top: 70px;
  @include mediaquery.minMediaMajor {
    padding-top: 100px;
  }
}

.share__heading {
  margin-bottom: 1em;
  @include mediaquery.minMediaMajor {
    font-size: 2.5rem;
  }
}

.share__back {
  margin-top: 30px;
  @include mediaquery.minMediaMajor {
    margin-top: 45px;
  }
}
</style>